<div class="modal-header border-0 pb-1">
    <h6 class="modal-title fw-bold">Change Power User Role Status</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
  
  <div class="modal-body  bg-body-tertiary rounded-3">
    <form #form="ngForm" (ngSubmit)="onSave(form)">
      <!-- First row: Power User # | From Status | To Status -->
      <div class="row mb-3 align-items-center">
        <div class="col-12 col-md-4">
          <label class="form-label mb-1 text-muted">Power User #</label>
          <input class="form-control form-control-sm" [value]="powerUserId" disabled>
        </div>
        <div class="col-6 col-md-4">
          <label class="form-label mb-1 text-muted">From Status</label>
          <input class="form-control form-control-sm" [value]="fromStatus" disabled>
        </div>
        <div class="col-6 col-md-4">
            <label for="toStatus" class="form-label mb-1">To Status <span class="text-danger">*</span></label>
            <select id="toStatus" class="form-select form-select-sm"
                    [(ngModel)]="toStatus" name="toStatus"
                    required
                    [ngClass]="{'is-invalid': formSubmitted && !toStatus}">
              <!-- <option value="" disabled selected>Select status</option> -->
              <option *ngFor="let status of statuses" [value]="status.Code" [disabled]="status.Code === 'Empty'">
                {{ status.Name }}
              </option>
            </select>
            <div *ngIf="formSubmitted && !toStatus" class="invalid-feedback d-block">Required</div>
          </div>
          
      </div>
  
      <!-- Info rows -->
      <div class="row g-3 mb-3">
        <div class="col-12 col-md-4">
          <label class="form-label mb-1 text-muted">Name</label>
          <input class="form-control form-control-sm" [value]="name" disabled>
        </div>

      </div>
  
      <!-- Comments -->
      <div class="row g-3 mb-2">
        <div class="col-12">
          <label for="comments" class="form-label mb-1">Comments/Notes <span class="text-danger">*</span></label>
          <textarea id="comments" rows="3" class="form-control form-control-sm"
            [(ngModel)]="comments" name="comments"
            required
            [ngClass]="{'is-invalid': formSubmitted && !comments}"></textarea>
          <div *ngIf="formSubmitted && !comments" class="invalid-feedback d-block">Required</div>
        </div>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-3">
    <button type="submit"
            class="btn btn-primary btn-sm px-4"
            [disabled]="!toStatus || !comments"
            (click)="onSave(form)">
      Save
    </button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="activeModal.dismiss()">Cancel</button>
  </div>
  